export const getOperatingSystem = () => {
  const platform = navigator.platform;

  if (platform.indexOf("Win") !== -1) {
    return "Windows";
  } else if (platform.indexOf("Mac") !== -1) {
    return "Mac";
  } else {
    return "Unknown";
  }
};

export const Cookie = {
  set: (name, val, isSafe, path = '/') => {
    document.cookie = `${name}=${encodeURIComponent(val)};path=${path};${isSafe?'samesite=None;secure;':''}`;
  },
  get: (name) => {
    let str = document.cookie;
    let arrStr = str.split("; ");
    //遍历数组
    for (let i = 0; i < arrStr.length; i++) {
      const arr = arrStr[i].split("=");
      if (arr[0] == name) {
        return arr[1];
      }
    }
  },
  getAll: () => {
    let str = document.cookie;
    let arrStr = str.split("; ");
    let newObj = {};
    //遍历数组
    for (let i = 0; i < arrStr.length; i++) {
      const arr = arrStr[i].split("=");
      newObj[arr[0]] = arr[1];
    }
    return newObj;
  },
  remove: (key) => {
    Cookie.set(key, "");
  },
  clearAll: () => {
    let obj = Cookie.getAll();
    for (let i in obj) {
      Cookie.remove(i);
    }
  }
};

export const getQueryObject = (str) => {
  var url = new URL(str);
  var queryParams = new URLSearchParams(url.search);
  var params = {};
  queryParams.forEach((value, key) => {
    params[key] = value;
  });

  return params
}

/**
 * 获取PDF文件页数
 * @param {string|TypedArray|PDFDataRangeTransport|DocumentInitParameters} pdfSource - PDF文件源
 * @returns {Promise<number>} 返回PDF页数的Promise
 */
export const getPdfPageCount = async (pdfSource) => {
  try {
    // 动态导入pdfjs-dist，避免在非PDF页面也加载这个较大的库
    const pdfJS = await import('pdfjs-dist');
    
    // 设置worker路径
    const pdfWorker = await import('pdfjs-dist/build/pdf.worker');
    pdfJS.GlobalWorkerOptions.workerSrc = pdfWorker.default;
    
    let source;
    // 如果传入的是File或Blob对象，需要先转换为Arraygit
    if (pdfSource instanceof File || pdfSource instanceof Blob) {
      source = await pdfSource.arrayBuffer();
    } else {
      source = pdfSource;
    }
    
    // 加载PDF文档
    const pdfDoc = await pdfJS.getDocument({ data: source }).promise;
    return pdfDoc.numPages;
  } catch (error) {
    throw new Error(`获取PDF页数失败: ${error.message}`);
  }
};


// WEBPACK FOOTER //
// ./src/utils/index.js